import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { WizardPrincipal } from './components/Wizard_Principal';
/*import { WizardPrincipal } from './components/WizardPrincipal';*/
import { Counter } from './components/Counter'; 
import { PrivateRoute } from './components/PrivateRoute';
import { authenticationService } from './services/authentication.service';
import { createBrowserHistory } from 'history';

import { loginRequest } from "./services/authConfig";
import { callMsGraph } from "./services/graph";
import { MsalContext } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

import './custom.css'
import { AppContext } from './AppContext';
//import { customFetch } from './services/customFetch';
import CasClient, { constant } from "react-cas-client";

const CAS_SERVER = process.env.REACT_APP_CAS_SERVER;
const APP_ID = process.env.REACT_APP_ID;
const API_URL = process.env.REACT_APP_API_URL;

const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: 'https' };
const casClient = new CasClient(CAS_SERVER, casOptions);

const history = createBrowserHistory();

export default class App extends Component {
	static displayName = App.name;

    constructor(props) {
        super(props);

        this.state = {
            username: null,
            currentUser: null
        };
    }

    componentDidMount() {
        //console.log("app state = " + JSON.stringify(this.state));
        const { username } = this.state;

        //if (!username) {
        //    casClient
        //        .auth()
        //        .then(successRes => {
        //            //console.log("App successRes = " + JSON.stringify(successRes)); this.setState({ username: successRes.user });
        //            history.replace(successRes.currentPath);
        //        })
        //        .catch(errorRes => { console.log("App errorRes = " + JSON.stringify(errorRes)) });
        //}
        //console.log("App componentDidMount");
        this.subscription = authenticationService.currentUser.subscribe(currentUser => {

            if (currentUser && currentUser.idpersona) {
                //console.log("App currentUser = " + JSON.stringify(currentUser));

                this.setState({ currentUser: currentUser });
                authenticationService.fetch();
            }
        });
        //customFetch.fetch(this.state.currentUser ? this.state.currentUser.token : null);
    }

	render() {
		//console.log("app state = " + JSON.stringify(this.state));

		//console.log("App render currentUser = " + JSON.stringify(this.state.currentUser));
		return (
		<Layout>
			<PrivateRoute exact path='/' component={WizardPrincipal} />
			<Route path='/logout' component={() => {
				casClient.logout();
				return null;
			}} />
		</Layout>
        );
    }
}
